// @flow

import * as React from 'react';

type Props = {
  text: string,
  children?: React.Node,
}

class NoElementFound extends React.Component<Props> {

  render() {
    return (
      <div className="no-element-container">
        <div className="no-element">
          <div className="text">
            {this.props.text}
          </div>
          <i className="fa fa-exclamation-triangle" />
          { this.props.children }
        </div>
      </div>
    );
  }
}

export default NoElementFound;
